// @flow
import { combineReducers } from 'redux';

import { DEFAULT_LOCATION } from '../settings';
import * as types from '../types/map';
import type { MAP_ACTION_TYPE } from '../types/map';
import * as common from './common';


export type MapState = {
  zoom: number,
  position: {
    latitude: number,
    longitude: number
  },
  animate: boolean,
  isPristine: boolean,
  isLoading: boolean,
  loadingMessage: string,
};

const position = (
  state: {
    latitude: number,
    longitude: number
  } = DEFAULT_LOCATION,
  action: MAP_ACTION_TYPE,
): { latitude: number, longitude: number } => {
  switch (action.type) {
    case types.SET_MAP_POSITION: {
      return {
        latitude: action.payload.latitude,
        longitude: action.payload.longitude,
      };
    }
    default:
      return state;
  }
};

const animate = (state: boolean = false, action: MAP_ACTION_TYPE): boolean => {
  switch (action.type) {
    case types.SET_MAP_POSITION: {
      return action.payload.animate;
    }
    default:
      return state;
  }
};


const zoom = (state: number = 15, action: MAP_ACTION_TYPE): number => {
  switch (action.type) {
    case types.SET_MAP_POSITION: {
      return action.payload.zoom;
    }
    default:
      return state;
  }
};

const isPristine = common.toggle({
  turnedOn: [types.MAP_PRISTINE_SET],
  turnedOff: [types.MAP_DIRTY_SET],
  default: true,
});

const isLoading = common.toggle({
  turnedOn: [types.MAP_SET_LOADING],
  turnedOff: [types.MAP_COMPLETED_LOADING],
  default: false,
});

const loadingMessage = (state = '', action: MAP_ACTION_TYPE) => {
  switch (action.type) {
    case types.MAP_SET_LOADING: return action.payload;
    case types.MAP_COMPLETED_LOADING: return '';
    default: return state;
  }
};

const routes = combineReducers({
  zoom,
  animate,
  position,
  isPristine,
  isLoading,
  loadingMessage,
});

export default routes;
export const getMapZoom = (state: MapState): number => state.zoom;
export const getMapPosition = (
  state: MapState,
): {latitude: number, longitude: number} => state.position;
export const getMapAnimate = (state: MapState): boolean => state.animate;
export const isMapPristine = (state: MapState): boolean => state.isPristine;
export const isMapLoading = (state: MapState): boolean => state.isLoading;
export const getMapLoadingMessage = (state: MapState): string => state.loadingMessage;



// WEBPACK FOOTER //
// ./src/scripts/reducers/map.js